import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

const RegisterSection = ({ color = "text-white" }) => {
  const history = useHistory();

  useEffect(() => {
    history.push("/login");
  }, []);

  return (
    <>
      <Link
        to="/login"
        className={`bg-orange-brand-500 hover:bg-gray-900 rounded text-white py-4 px-4`}
      >
        REGISTER
      </Link>
      <h3 className={`mt-10 mb-5 pressura text-base font-normal ${color}`}>
        Already a PMI user?&nbsp;
        <Link to="/login" className="no-underline text-orange-brand-500">
          Log in
        </Link>
      </h3>
    </>
  );
};

export default RegisterSection;
